import React, {useEffect, useState} from 'react';
import {Box} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import DebtorItem from './item/item';
import HeaderBox from './header-box';
import SemaphoreItem from '../dashboard/SemaphoreItem';
import {IDebtorItem, ISemaphoreValue} from '../../../../interfaces/dtos';
import {getSemaphoreColor} from '../../../../constants/semaphore';
import InternalTemplate from '../../../../components/templates/internal';
import {StackParamList} from '../../../../navigators';
import {SpinnerModal} from '../../../../components/modals';
import useClientContext from '../../../../context/client/Context';
import {isOdd} from '../../../../utils/ui';

type ScreenProps = NativeStackScreenProps<StackParamList, 'Debtors'>;

interface ISemaphoreChart {
  semaphoreValue: ISemaphoreValue | null;
}

const SemaphoreChart = ({semaphoreValue}: ISemaphoreChart) => {
  if (semaphoreValue) {
    const {key, ...props} = semaphoreValue;
    return (
      <Box padding={2}>
        <SemaphoreItem
          key={key}
          {...props}
          label={`label-${semaphoreValue.key}`}
          color={getSemaphoreColor(semaphoreValue.key)}
        />
      </Box>
    );
  }

  return <></>;
};

interface IHeader {
  isLoading: Boolean;
}
const Header = ({isLoading}: IHeader) => {
  if (isLoading) {
    return <></>;
  }
  return <HeaderBox />;
};

interface IDebtorsContent {
  isLoading: Boolean;
  debtors: IDebtorItem[] | null;
  onItemSelection: (index: number) => void;
}

const DebtorsContent = ({
  isLoading,
  debtors,
  onItemSelection: handleSelectItem,
}: IDebtorsContent) => {
  if (isLoading) {
    return <></>;
  }
  if (debtors) {
    return (
      <>
        {debtors.map((debtor: IDebtorItem, index: number) => (
          <DebtorItem
            key={`balance-item-${index}`}
            {...debtor}
            onPress={() => handleSelectItem(index)}
            rowType={isOdd(index) ? 'odd' : 'even'}
          />
        ))}
      </>
    );
  }

  return <></>;
};

const DebtorsScreen = ({navigation, route}: ScreenProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const {
    clientPortfolioFilter,
    fetchSemaphoreItems,
    semaphoreItems: semaphoreValues,
    fetchDebtorList,
    debtors,
  } = useClientContext();

  const {position} = route.params;
  const [semaphoreValue, setSemaphoreValue] = useState(
    null as ISemaphoreValue | null,
  );

  const getSemaphoreValue = async (
    list: ISemaphoreValue[] | null,
    point: number,
  ) => {
    if (list) {
      return list[point];
    }
    return null;
  };

  const getDebtorList = async () => {
    setIsLoading(true);
    const value = await getSemaphoreValue(semaphoreValues, position);
    setSemaphoreValue(value);
    if (value) {
      await fetchDebtorList(value.key, clientPortfolioFilter);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (semaphoreValues) {
      getDebtorList();
    } else {
      fetchSemaphoreItems();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [semaphoreValues]);

  const handleGoBack = () => {
    navigation.navigate('DashboardClient');
  };

  const handleSelectItem = (index: number) => {
    if (debtors) {
      if (semaphoreValue && debtors[index]) {
        navigation.navigate('Receivables', {
          key: semaphoreValue.key,
          debtor: debtors[index],
        });
      }
    }

    //navigation.navigate('BalanceDetail', filtered[index]);
  };

  return (
    <InternalTemplate
      title={'screen-debtors-list-title'}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'back-dashboard',
        usage: 'external',
      }}>
      <SpinnerModal show={isLoading} />
      <Box paddingX={3}>
        <SemaphoreChart semaphoreValue={semaphoreValue} />
      </Box>
      <Header isLoading={isLoading} />
      <Box marginBottom={20}>
        <DebtorsContent
          isLoading={isLoading}
          debtors={debtors}
          onItemSelection={handleSelectItem}
        />
      </Box>
    </InternalTemplate>
  );
};
export default DebtorsScreen;
